import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { api } from "../../lib/api";

export const WaitlistDialog = ({ item, open, onOpenChange }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/waitlist", { email, category: item.id });
      toast.success(data?.already ? `You're already on the ${item.title} waitlist.` : `You're on the ${item.title} waitlist.`);
      setEmail("");
      onOpenChange(false);
    } catch {
      toast.error("Please enter a valid email address.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl gap-0 overflow-hidden rounded-none border-line bg-ivory p-0 md:grid md:grid-cols-2" data-testid={`waitlist-dialog-${item.id}`}>
        <img src={item.img} alt={item.title} style={{ objectPosition: item.pos ?? "center" }} className="hidden h-full max-h-[460px] w-full object-cover md:block" />
        <form onSubmit={submit} className="flex flex-col gap-5 p-7 md:p-10">
          <p className="label-mono">Waitlist · {item.tag}</p>
          <DialogTitle className="font-display text-4xl font-light leading-tight text-ink">{item.title}</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-graphite">
            Be first to know when {item.title.toLowerCase()} launch. We'll only email you about this category.
          </DialogDescription>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
            data-testid={`waitlist-email-${item.id}`} className="w-full border-b border-ink bg-transparent py-3 text-base text-ink outline-none placeholder:text-graphite" />
          <button disabled={busy} className="btn-dark mt-auto" data-testid={`waitlist-submit-${item.id}`}>{busy ? "Joining…" : "Join the waitlist"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
